import * as _ from 'lodash';
import { getComponent } from './rendererJson';

export const findIdSelector = (state: any, formId: string, ids: string[], status  = false, providedForm = []) => {
    const fields = _.isEmpty(providedForm) ? (state.formcreation[formId]) ? state.formcreation[formId] : [] : providedForm; 
    if(fields) {
        let field = fields;
        let resFind: any;
        let id = '';
        _.each(ids, (value, key) => {
            id  += (key === 0) ? value : "#"+ value
            const find = _.find(field, ['id', id.trim()]);
            if(find) {
                field = find.fields
                if(find.id === ids.join('#')){
                    resFind = find
                }
            }
        })
        // if(!resFind) {
        //     const idsSplit = ids[0].split('#');
        //     id = '';
        //     let FindField = fields;
        //     _.each(idsSplit, (value, key) => {
        //         id  += (key === 0) ? value : "#"+ value
        //         const f = _.find(FindField, ['id', id.trim()]);
        //         if(f && key + 1 !== idsSplit.length) {
        //             FindField = f.fields
        //         }
        //         if(key + 1 === idsSplit.length) {
        //             resFind = f
        //         }
        //     })
        // }
        if(status) return resFind;
        return resFind && resFind.fields &&  resFind.fields.map((redux: any) => {
            return { ...redux, Component: getComponent(redux.label) }
        })
    }

    return []
}

